import { Spin, SpinProps } from 'antd'
import * as React from 'react'

type ConditionalSpinnerProps = {
  loading: boolean | SpinProps
  minHeight?: string | number
  children: React.ReactNode
  viewChildren?: boolean
} & SpinProps

export function ConditionalSpinner({
  loading,
  children,
  minHeight,
  viewChildren = true,
  ...spinProps
}: ConditionalSpinnerProps): JSX.Element {
  return loading ? (
    <Spin
      {...spinProps}
      style={{
        height: '100%',
        minHeight: minHeight || '400px',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {viewChildren && children}
    </Spin>
  ) : (
    <>{children}</>
  )
}
